import { render, staticRenderFns } from "./site-owner-info.vue?vue&type=template&id=047dc060&"
import script from "./site-owner-info.vue?vue&type=script&lang=js&"
export * from "./site-owner-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports